import { Link } from 'react-router-dom';
import { HrmDualToneTitle } from '../hrm/HrmDualToneTitle';
import { useLocalizedPath } from '@/lib/i18n/useLocale';
import img1 from '@/assets/Customer feedback1.png';
import img2 from '@/assets/Customer feedback2.png';

export function CrmIntegratedManagement({
    title,
    description,
    icon,
    id,
}: {
    title: string;
    description: string;
    icon?: string;
    id?: string;
}) {
    const localizedPath = useLocalizedPath();

    const content = (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-14 items-center cursor-pointer">
            {/* Illustration */}
            <div className="flex justify-center lg:justify-start motion-safe:animate-float">
                {/* {icon === 'attendance' ? <Attendance /> : <Contracts />} */}
                <img src={icon === 'attendance' ? img1 : img2} alt={title} className="w-full h-full object-contain" />
            </div>

            <div className="lg:col-span-2 col-span-1 flex flex-col justify-center lg:p-0 p-4">
                <HrmDualToneTitle title={title} />
                <p className="mt-6 text-primary-text/90 font-medium  sm:text-base text-[15px] lg:text-[20px] leading-relaxed pl-6 ml-auto">
                    {description}
                </p>
            </div>
        </div>
    );

    return (
        <section className="lg:my-[60px] md:my-[40px] sm:my-[30px] my-[20px] shadow-sm rounded-lg p-4">
            {id ? <Link to={localizedPath(`/crm/${id}`)}>{content}</Link> : content}
        </section>
    );
}
